<!-- ============================================================== -->
<!-- Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->
<div class="page-breadcrumb" *ngIf="read==true || write==true || delete ==true">
    <div class="row">
        <div class="col-7 align-self-center">

            <h4 class="page-title">Admin User Management</h4>
        </div>

    </div>
</div>
<!-- ============================================================== -->
<!-- End Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->
<!-- <div  style="margin-top: 37px;" *ngIf="write!=true && read!=true && delete!=true ">
   
    <div class="box">
        <div class="text-center">
          
            <p class="text-muted my-4" style="color:#353556!important;font-size: x-large;font-weight: 600;font-family: initial;">YOU DON'T HAVE ANY PERMISSION TO ACCESS ON THIS PAGE.</p>
            
        </div>
    </div>
</div> -->

<div style="display: block;Width:12%;margin-left: 30px;" *ngIf="write==true">
    <div class="mt-3" >
        <a *ngIf="!show" href="javascript:void(0)" (click)="addAdmin()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Add </span>
        </a>
        <a *ngIf="show" href="javascript:void(0)" (click)="addAdmin()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-minus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Remove </span>
        </a>
    </div>
</div>
<!-- ============================================================== -->


<div *ngIf="show">
    <div>

        <div class="container-fluid" >
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <div class="row">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <form #adminUser="ngForm" novalidate>
                                <div class="form-body">
                                    <h3 class="card-title"> Admin User</h3>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span> First
                                                    Name</label>
                                                <input type="text" id="firstName" required #firstName="ngModel"
                                                    minlength="3" maxlength="30" pattern="^[^\d\W]+( [^\d\W]+)*$"
                                                    name="firstName" [(ngModel)]="adminUserAddObj.firstName"
                                                    onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                                    class="form-control" placeholder="  First Name">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!firstName.errors.required"
                                                    *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">
                                                    This Field is Required</span>
                                                <span class="text-danger" [hidden]="!firstName.errors?.pattern"
                                                    *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">
                                                    First Name Should Be Only Alphabets</span>
                                                <span class="text-danger"
                                                    [hidden]="!firstName.errors?.minlength || firstName.errors.pattern"
                                                    *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">First
                                                    Name Should Be Min 3 Characters</span>

                                            </div>
                                        </div>
                                        <!--/span-->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Last
                                                    Name </label>
                                                <input type="text" id="lastName" class="form-control" required
                                                    minlength="3" maxlength="30" #lastName="ngModel" name="lastName"
                                                    [(ngModel)]="adminUserAddObj.lastName" placeholder="Last Name"
                                                    onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                                    minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!lastName.errors.required"
                                                    *ngIf="lastName.errors && (lastName.touched || lastName.dirty)">
                                                    *This Field is Required</span>
                                                <span class="text-danger" [hidden]="!lastName.errors?.pattern"
                                                    *ngIf="lastName.errors && (lastName.touched || lastName.dirty)">
                                                    Last Name Should Be Only Alphabets</span>
                                                <span class="text-danger"
                                                    [hidden]="!lastName.errors?.minlength || lastName.errors.pattern"
                                                    *ngIf="lastName.errors && (lastName.touched || firstName.dirty)">Last
                                                    Name Should Be Min 3 Characters</span>
                                            </div>
                                        </div>
                                        <!--/span-->
                                    </div>

                                    <!--/row-->
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Mobile
                                                    Number</label>
                                                <input type="tel" id="mobileNumber" required
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                    #mobileNumber="ngModel" name="mobileNumber" maxlength=15
                                                    [(ngModel)]="adminUserAddObj.mobileNumber" class="form-control"
                                                    placeholder="Mobile Number">
                                                <span class="text-danger" [hidden]="!mobileNumber.errors.required"
                                                    *ngIf="mobileNumber.errors && (mobileNumber.touched || mobileNumber.dirty)">This
                                                    Field
                                                    is Required
                                                </span>
                                                <span class="text-danger"
                                                    [hidden]="!mobileNumber.errors?.minlength || mobileNumber.errors.pattern"
                                                    *ngIf="mobileNumber.errors && (mobileNumber.touched || mobileNumber.dirty)">
                                                    Mobile Number Should not exceed 15 digits</span>
                                            </div>
                                        </div>
                                        <!--/span-->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">
                                                    <span class="text-danger">*</span>Email Id</label>
                                                <input type="email" id="emailId" required #emailId="ngModel"
                                                    name="emailId" [(ngModel)]="adminUserAddObj.emailId"
                                                    pattern="[a-zA-Z0-9._]{2,}@[a-zA-Z]{2,}\.[a-zA-Z]{2,3}$"
                                                    maxlength="40" class="form-control" placeholder="Email Id">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!emailId.errors.required"
                                                    *ngIf="emailId.errors && (emailId.touched || emailId.dirty)">This
                                                    Field is Required</span>
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!emailId.errors.pattern"
                                                    *ngIf="emailId.errors && (emailId.touched || emailId.dirty)">Please
                                                    Enter Valid Email </span>
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!emailId.errors.maxlength || emailId?.errors.pattern"
                                                    *ngIf="emailId.errors">
                                                    valid email.</span>
                                            </div>
                                        </div>
                                        <!--/span-->
                                    </div>
                                    <!--/row-->
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>Role
                                                    Name</label>
                                                <select class="form-control" required #roleId="ngModel" name="roleId"
                                                    [(ngModel)]="adminUserAddObj.roleId"
                                                    data-placeholder="Choose a Role Name" tabindex="1">
                                                    <option disabled="" value="" selected>Role</option>

                                                    <option *ngFor="let rl of rolesList" value="{{rl.id}}">
                                                        {{rl.role_name}}</option>

                                                </select>
                                                <span class="text-danger" [hidden]="!roleId.errors.required"
                                                    *ngIf="roleId.errors && (roleId.touched || roleId.dirty)">*Please
                                                    select Role
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span
                                                        class="text-danger">*</span>Password</label>
                                                <input type="password" id="passWord" required #passWord="ngModel"
                                                    name="passWord" [(ngModel)]="adminUserAddObj.passWord"
                                                    class="form-control" placeholder="password">
                                                <span class="text-danger" [hidden]="!passWord.errors.required"
                                                    *ngIf="passWord.errors && (passWord.touched || passWord.dirty)">*This
                                                    Field is required
                                                </span>
                                            </div>
                                        </div>

                                        <!--/span-->
                                    </div>
                                    <!--/row-->


                                    <!--/row-->
                                    <div class="row">



                                        <!--/span-->
                                        <div class="col-md-3">
                                            <h5 class="card-title m-t-20"> <span class="text-danger">*</span>Profile
                                                Photo</h5>


                                            <div class="btn btn-info waves-effect waves-light">
                                                <input type="file" id="container"
                                                    accept="image/gif, image/jpeg, image/png"
                                                    (change)="fileChangeEvent($event)" required #profilePhoto="ngModel"
                                                    name="profilePhoto" [(ngModel)]="adminUserAddObj.profilePhoto"
                                                    class="upload"> </div>
                                            <span class="text-danger" [hidden]="!profilePhoto.errors.required"
                                                *ngIf="profilePhoto.errors && (profilePhoto.touched || profilePhoto.dirty)">*This
                                                Field is required
                                            </span>
                                        </div>

                                    </div>
                                    <img width="45.25em" height="46.25em" [src]="pic" height="150" width="200px"
                                        style="margin: 3px;"> <br />

                                </div>
                                <br>
                                <br>
                                <br>
                                <div class="form-actions m-t-40">
                                    <button type="submit" style="background-color: #353556;color:white" class="btn"
                                        (click)="saveAdminUser()" [disabled]="!adminUser.valid">
                                        <i class="fa fa-check"></i> Submit</button> &nbsp;&nbsp;
                                    <button type="button" class="btn btn-dark" (click)="addAdmin()"
                                        data-dismiss="modal">Cancel</button>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Column -->
            </div>
            <!-- ============================================================== -->
            <!-- End PAge Content -->
            <!-- ============================================================== -->
            <!-- ============================================================== -->
            <!-- Right sidebar -->
            <!-- ============================================================== -->
            <!-- .right-sidebar -->
            <!-- ============================================================== -->
            <!-- End Right sidebar -->
            <!-- ============================================================== -->
        </div>
        <!-- ============================================================== -->
        <!-- End Container fluid  -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->

        <!-- ============================================================== -->
    </div>
</div>


<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" >
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row">
        <!-- Column -->
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <diV class="row">
                                <div class="col-md-10">
                                    <label style="color: black;">All Admin users</label>
                                </div>

                                <div class="col-md-1">
                                    <div id="zero_config_filter" class="dataTables_filter">
                                        <button style="background-color: #e0e09e" (click)="filter()">
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                            Filter</button>
                                    </div>

                                </div>
                                <div class="col-md-1">

                                    <div id="zero_config_filter" class="dataTables_filter" *ngIf="export==true">
                                        <button style="background-color: #e0e09e" (click)="exportTable()">
                                            <i class="fa fa-download" aria-hidden="true"></i>
                                            Export</button>
                                    </div>

                                </div>
                            </diV>
                            <div *ngIf="showFilter" style="background-color: #e0e09e;width: 895px;">
                                <div class="container-fluid" style="color: black">
                                    <input type="radio" id="firstName" name="gender" [(ngModel)]="filterValueSelected" value="f" (change)="applyCustomizedFilter()" style="margin-top: 29px;"> First Name &nbsp;&nbsp;
                                    <input type="radio" id="lastName" name="gender" [(ngModel)]="filterValueSelected" value="l"  (change)="applyCustomizedFilter()"> Last Name &nbsp;&nbsp;
                                    <input type="radio" id="emailId" name="gender" [(ngModel)]="filterValueSelected" value="ei" (change)="applyCustomizedFilter()"> Email Address &nbsp;&nbsp;
                                    <input type="radio" id="mobile" name="gender" [(ngModel)]="filterValueSelected" value="mn"  (change)="applyCustomizedFilter()"> Mobile Number &nbsp;&nbsp;
                                   
                                   
                                </div>
                                <div style="margin-left: 820px">
                                   
                                    <button class="btn btn-dark" (click)="filter()">Cancel</button>

                                </div>
                            </div>

                            <div>
                                <div>
                                    <mat-form-field *ngIf="showCustomisedSearch">

                                        <input class="search" placeholder="Search" matInput  [(ngModel)]="searchValue"
                                            (keyup)="applyCustomizedFilterSearch(searchValue)">

                                    </mat-form-field>
                                    <mat-form-field *ngIf="!showCustomisedSearch">

                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>

                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table [dataSource]="dataSource" matSort>

                                        <ng-container matColumnDef="firstName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
                                            <!-- <td *matCellDef="let row"  *ngIf="row.status==Active" style="padding-left: 14px;background-color: gray;" >{{row.firstName}}</td> -->

                                            <td *matCellDef="let row" >
                                                {{row.firstName}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="lastName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
                                            <td *matCellDef="let row" >
                                                {{row.lastName}}
                                            </td>
                                            
                                        </ng-container>
                                        <ng-container matColumnDef="mobileNumber">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number</th>
                                            <td *matCellDef="let row">
                                                {{row.mobileNumber}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="mobileNumberStatus">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number Status</th>
                                            <td *matCellDef="let row">
                                                <span *ngIf="row.mobileNumberStatus=='Verified'"> Verified</span>
                                                <span *ngIf="row.mobileNumberStatus=='NotVerified'">Not  Verified</span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="emailId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email Id</th>
                                            <td *matCellDef="let row">
                                                {{row.emailId}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="emailIdStatus">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email Id Status</th>
                                            <td *matCellDef="let row">
                                                {{row.emailAddressStatus}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="roleId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Role Id</th>
                                            <td *matCellDef="let row">
                                                {{row.roleId}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="RoleName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Role Name</th>
                                            <td *matCellDef="let row">
                                                {{row.RoleName}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="profilePhoto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Profile Photo</th>
                                            <td *matCellDef="let row">
                                                <a target="blank" href="{{myurl+'Misc/Images/profilePhotos/'+row._id}}">View</a>
                                              

                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Admin User Status</th>
                                            <td *matCellDef="let row">
                                                <span *ngIf="row.status==true"> Active</span>
                                                <span *ngIf="row.status==false"> In Active</span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="dateOfCreation">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
                                            <td *matCellDef="let row">
                                                {{row.dateOfCreation|date}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="dateOfModification">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Modified Date
                                            </th>
                                            <td *matCellDef="let row">
                                                {{row.dateOfModification|date}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="Action">
                                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                                            <td *matCellDef="let row">
                                                <p *ngIf="read==true && write !=true && delete !=true"
                                                    style="color:#353556;font-family: initial;font-weight: 500;">You
                                                    don't have permissions to Edit/Delete</p>
                                                <ul class="list-group list-group-flush"
                                                    *ngIf="write==true||delete==true">
                                                    <li class="list-group-item  friend-list mb-2">

                                                        <div class="dropdown show float-right list-block">

                                                            <a class="userDropdown" href="#" role="button"
                                                                id="userDropdown" data-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false"
                                                                style="padding-right: 170px;"></a>
                                                            <div class="dropdown-menu dropdown-menu-right"
                                                                aria-labelledby="userDropdown">
                                                                <button class="dropdown-item" data-toggle="modal"
                                                                    *ngIf="write==true" data-target="#responsive"
                                                                    (click)="getByAdminId(row._id)">
                                                                    <i class="fa fa-address-card"
                                                                        aria-hidden="true"></i>&nbsp;&nbsp;Edit</button>
                                                                <button class="dropdown-item"
                                                                    (click)="deleteAdminUser(row._id)"
                                                                    *ngIf="delete==true">
                                                                    <i class="fa fa-trash p-2"
                                                                        aria-hidden="true"></i>Delete</button>
                                                                <div *ngIf="write==true">
                                                                    <mat-slide-toggle
                                                                        (change)="onChange($event,row._id)"
                                                                        [checked]="row.status">
                                                                        <span *ngIf="row.status==false">
                                                                            In Active</span>
                                                                        <span *ngIf="row.status==true">
                                                                            Active</span>
                                                                    </mat-slide-toggle>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>

                        </div>
                    </div>
                    <mat-paginator style="margin-right:200px" [length]="100" [pageSize]="10"
                        [pageSizeOptions]="[5, 10, 25,100]" showFirstLastButtons>
                    </mat-paginator>

                </div>
            </div>
        </div>
        <!-- Column -->
    </div>
    <!-- ============================================================== -->
    <!-- End PAge Content -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right sidebar -->
    <!-- ============================================================== -->
    <!-- .right-sidebar -->
    <!-- ============================================================== -->
    <!-- End Right sidebar -->
    <!-- ============================================================== -->
</div>
<!-- ============================================================== -->
<!-- End Container fluid  -->
<!-- ============================================================== -->
<!-- ============================================================== -->
<!-- ============================================================== -->
<div id="responsive" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content bigModel" style="width:900px">
            <div class="modal-header">
                <h4>Edit Admin User Management</h4>
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <form #adminUserUpdate="ngForm" novalidate>
                    <div class="form-body">
                        <div class="row">
                            <!-- <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> User ID</label>
                                    <input type="text" id="userid"  #id="ngModel" name="id"
                                        [(ngModel)]="adminUserAddObj.id" class="form-control"
                                        placeholder="User Id">
                                </div>
                            </div> -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span> First Name</label>
                                    <input type="text" id="firstName" required #firstName="ngModel" name="firstName"
                                        minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$"
                                        [(ngModel)]="adminUserAddObj.firstName" class="form-control"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                        placeholder="  First Name">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!firstName.errors.required"
                                        *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">
                                        This Field is Required</span>
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!firstName.errors.required"
                                        *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">
                                        This Field is Required</span>
                                    <span class="text-danger" [hidden]="!firstName.errors?.pattern"
                                        *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">
                                        First Name Should Be Only Alphabets</span>
                                    <span class="text-danger"
                                        [hidden]="!firstName.errors?.minlength || firstName.errors.pattern"
                                        *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">First
                                        Name Should Be Min 3 Characters</span>

                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Last Name </label>
                                    <input type="text" id="lastName" class="form-control" required #lastName="ngModel"
                                        minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$" name="lastName"
                                        [(ngModel)]="adminUserAddObj.lastName" placeholder="Last Name"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!lastName.errors.required"
                                        *ngIf="lastName.errors && (lastName.touched || lastName.dirty)">
                                        *This Field is Required</span>
                                    <span class="text-danger" [hidden]="!lastName.errors?.pattern"
                                        *ngIf="lastName.errors && (lastName.touched || lastName.dirty)">
                                        Last Name Should Be Only Alphabets</span>
                                    <span class="text-danger"
                                        [hidden]="!lastName.errors?.minlength || lastName.errors.pattern"
                                        *ngIf="lastName.errors && (lastName.touched || firstName.dirty)">Last
                                        Name Should Be Min 3 Characters</span>
                                </div>
                            </div>
                        </div>

                        <!--/row-->
                        <div class="row">

                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Mobile
                                        Number</label>
                                    <input type="tel" id="mobileNumber" required
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength=15
                                        #mobileNumber="ngModel" name="mobileNumber"
                                        [(ngModel)]="adminUserAddObj.mobileNumber" class="form-control"
                                        placeholder="Mobile Number">
                                    <span class="text-danger" [hidden]="!mobileNumber.errors.required"
                                        *ngIf="mobileNumber.errors && (mobileNumber.touched || mobileNumber.dirty)">This
                                        Field
                                        is Required
                                    </span>
                                    <span class="text-danger"
                                        [hidden]="!mobileNumber.errors?.minlength || mobileNumber.errors.pattern"
                                        *ngIf="mobileNumber.errors && (mobileNumber.touched || mobileNumber.dirty)">
                                        Mobile Number Should not exceed 15 digits</span>
                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">
                                        <span class="text-danger">*</span>Email Id</label>
                                    <input type="email" id="emailId" required #emailId="ngModel" name="emailId"
                                        [(ngModel)]="adminUserAddObj.emailId" class="form-control"
                                        pattern="[a-zA-Z0-9._]{2,}@[a-zA-Z]{2,}\.[a-zA-Z]{2,3}$" maxlength="40"
                                        placeholder="Email Id">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!emailId.errors.required"
                                        *ngIf="emailId.errors && (emailId.touched || emailId.dirty)">This
                                        Field is Required</span>
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!emailId.errors.pattern"
                                        *ngIf="emailId.errors && (emailId.touched || emailId.dirty)">Please
                                        Enter Valid Email </span>
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!emailId.errors.maxlength || emailId?.errors.pattern"
                                        *ngIf="emailId.errors">
                                        valid email.</span>
                                </div>
                            </div>
                            <!--/span-->
                        </div>
                        <!--/row-->
                        <div class="row">

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Role Name</label>
                                    <select class="form-control" required #roleId="ngModel" name="roleId"
                                        [(ngModel)]="adminUserAddObj.roleId" data-placeholder="Choose a Role Name"
                                        tabindex="1">
                                        <option disabled="" value="" selected="selected">Role</option>

                                        <option *ngFor="let rl of rolesList" value="{{rl.id}}">
                                            {{rl.role_name}}</option>

                                    </select>
                                    <span class="text-danger" [hidden]="!roleId.errors.required"
                                        *ngIf="roleId.errors && (roleId.touched || roleId.dirty)">*Please
                                        select Role
                                    </span>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <h5 class="card-title m-t-20">Profile
                                    Photo</h5>


                                <div class="btn btn-info waves-effect waves-light">
                                    <input type="file" id="container" accept="image/gif, image/jpeg, image/png"
                                        (change)="fileChangeEvent($event)" #profilePhoto="ngModel" name="profilePhoto"
                                        [(ngModel)]="adminUserAddObj.profilePhoto" class="upload"> </div>
                                <span class="text-danger" [hidden]="!profilePhoto.errors.required"
                                    *ngIf="profilePhoto.errors && (profilePhoto.touched || profilePhoto.dirty)">*This
                                    Field is required
                                </span>
                            </div>
                            <img width="45.25em" height="46.25em" [src]="pic" height="150" width="200px"
                                style="margin: 3px;"> <br />

                        </div>
                        <!--/row-->




                    </div>
                    <br>
                    <br>
                    <br>
                    <div class="form-actions m-t-40">
                        <button type="submit" style="background-color: #353556;color:white"
                            [disabled]="!adminUserUpdate.valid" data-dismiss="modal" class="btn"
                            (click)="updateAdminUser()">
                            <i class="fa fa-check"></i> Update</button>&nbsp;&nbsp;
                        <button type="button" class="btn btn-dark" data-dismiss="modal">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div id="Otp" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content bigModel" style="width:900px">
            <div class="modal-header">
                <h4>Mobile Verification</h4>
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <form #adminUserUpdate="ngForm" novalidate>
                    <div class="form-body">
                        <div class="row">
                            <!-- <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> User ID</label>
                                    <input type="text" id="userid"  #id="ngModel" name="id"
                                        [(ngModel)]="adminUserAddObj.id" class="form-control"
                                        placeholder="User Id">
                                </div>
                            </div> -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span> First Name</label>
                                    <input type="text" id="firstName" required #firstName="ngModel" name="firstName"
                                        minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$"
                                        [(ngModel)]="adminUserAddObj.firstName" class="form-control"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"
                                        placeholder="  First Name">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!firstName.errors.required"
                                        *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">
                                        This Field is Required</span>
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!firstName.errors.required"
                                        *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">
                                        This Field is Required</span>
                                    <span class="text-danger" [hidden]="!firstName.errors?.pattern"
                                        *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">
                                        First Name Should Be Only Alphabets</span>
                                    <span class="text-danger"
                                        [hidden]="!firstName.errors?.minlength || firstName.errors.pattern"
                                        *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">First
                                        Name Should Be Min 3 Characters</span>

                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Last Name </label>
                                    <input type="text" id="lastName" class="form-control" required #lastName="ngModel"
                                        minlength="3" maxlength="40" pattern="^[^\d\W]+( [^\d\W]+)*$" name="lastName"
                                        [(ngModel)]="adminUserAddObj.lastName" placeholder="Last Name"
                                        onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!lastName.errors.required"
                                        *ngIf="lastName.errors && (lastName.touched || lastName.dirty)">
                                        *This Field is Required</span>
                                    <span class="text-danger" [hidden]="!lastName.errors?.pattern"
                                        *ngIf="lastName.errors && (lastName.touched || lastName.dirty)">
                                        Last Name Should Be Only Alphabets</span>
                                    <span class="text-danger"
                                        [hidden]="!lastName.errors?.minlength || lastName.errors.pattern"
                                        *ngIf="lastName.errors && (lastName.touched || firstName.dirty)">Last
                                        Name Should Be Min 3 Characters</span>
                                </div>
                            </div>
                        </div>

                        <!--/row-->
                        <div class="row">

                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Mobile
                                        Number</label>
                                    <input type="tel" id="mobileNumber" required
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength=15
                                        #mobileNumber="ngModel" name="mobileNumber"
                                        [(ngModel)]="adminUserAddObj.mobileNumber" class="form-control"
                                        placeholder="Mobile Number">
                                    <span class="text-danger" [hidden]="!mobileNumber.errors.required"
                                        *ngIf="mobileNumber.errors && (mobileNumber.touched || mobileNumber.dirty)">This
                                        Field
                                        is Required
                                    </span>
                                    <span class="text-danger"
                                        [hidden]="!mobileNumber.errors?.minlength || mobileNumber.errors.pattern"
                                        *ngIf="mobileNumber.errors && (mobileNumber.touched || mobileNumber.dirty)">
                                        Mobile Number Should not exceed 15 digits</span>
                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">
                                        <span class="text-danger">*</span>Email Id</label>
                                    <input type="email" id="emailId" required #emailId="ngModel" name="emailId"
                                        [(ngModel)]="adminUserAddObj.emailId" class="form-control"
                                        pattern="[a-zA-Z0-9._]{2,}@[a-zA-Z]{2,}\.[a-zA-Z]{2,3}$" maxlength="40"
                                        placeholder="Email Id">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!emailId.errors.required"
                                        *ngIf="emailId.errors && (emailId.touched || emailId.dirty)">This
                                        Field is Required</span>
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!emailId.errors.pattern"
                                        *ngIf="emailId.errors && (emailId.touched || emailId.dirty)">Please
                                        Enter Valid Email </span>
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!emailId.errors.maxlength || emailId?.errors.pattern"
                                        *ngIf="emailId.errors">
                                        valid email.</span>
                                </div>
                            </div>
                            <!--/span-->
                        </div>
                        <!--/row-->
                        <div class="row">

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span>Role Name</label>
                                    <select class="form-control" required #roleId="ngModel" name="roleId"
                                        [(ngModel)]="adminUserAddObj.roleId" data-placeholder="Choose a Role Name"
                                        tabindex="1">
                                        <option disabled="" value="" selected="selected">Role</option>

                                        <option *ngFor="let rl of rolesList" value="{{rl.id}}">
                                            {{rl.role_name}}</option>

                                    </select>
                                    <span class="text-danger" [hidden]="!roleId.errors.required"
                                        *ngIf="roleId.errors && (roleId.touched || roleId.dirty)">*Please
                                        select Role
                                    </span>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <h5 class="card-title m-t-20">Profile
                                    Photo</h5>


                                <div class="btn btn-info waves-effect waves-light">
                                    <input type="file" id="container" accept="image/gif, image/jpeg, image/png"
                                        (change)="fileChangeEvent($event)" #profilePhoto="ngModel" name="profilePhoto"
                                        [(ngModel)]="adminUserAddObj.profilePhoto" class="upload"> </div>
                                <span class="text-danger" [hidden]="!profilePhoto.errors.required"
                                    *ngIf="profilePhoto.errors && (profilePhoto.touched || profilePhoto.dirty)">*This
                                    Field is required
                                </span>
                            </div>
                            <img width="45.25em" height="46.25em" [src]="pic" height="150" width="200px"
                                style="margin: 3px;"> <br />

                        </div>
                        <!--/row-->




                    </div>
                    <br>
                    <br>
                    <br>
                    <div class="form-actions m-t-40">
                        <button type="submit" style="background-color: #353556;color:white"
                            [disabled]="!adminUserUpdate.valid" data-dismiss="modal" class="btn"
                            (click)="updateAdminUser()">
                            <i class="fa fa-check"></i> Update</button>&nbsp;&nbsp;
                        <button type="button" class="btn btn-dark" data-dismiss="modal">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>